class CartReservationTimer extends HTMLElement {
  connectedCallback() {
    const duration = parseInt(this.dataset.duration || '900', 10); // segundos, 900 = 15 min
    const storageKey = 'cart-reservation-start';
    let start = sessionStorage.getItem(storageKey);

    if (!start) {
      start = Date.now();
      sessionStorage.setItem(storageKey, start);
    } else {
      start = parseInt(start, 10);
    }

    this.endTime = start + duration * 1000;
    this.timeEl = this.querySelector('[data-key="time"]');
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  tick() {
    const remaining = Math.max(0, Math.floor((this.endTime - Date.now()) / 1000));
    const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
    const seconds = String(remaining % 60).padStart(2, '0');

    if (this.timeEl) this.timeEl.textContent = `${minutes}:${seconds}`;

    if (remaining <= 0) {
      clearInterval(this.interval);
      sessionStorage.removeItem('cart-reservation-start');
      this.remove();
    }
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

if (!customElements.get('cart-reservation-timer')) {
  customElements.define('cart-reservation-timer', CartReservationTimer);
}